import Department from './Department';
import Team from './Team';

export default class ClubEmployeeDepartmentsAndTeams {
    static fromData(data) {
        if (!data) {
            return;
        }

        let clubEmployeeDepartmentsAndTeams = new ClubEmployeeDepartmentsAndTeams();
        clubEmployeeDepartmentsAndTeams.departments = [];
        if (data.departments) {
            clubEmployeeDepartmentsAndTeams.departments = data.departments.data.map(departmentData => Department.fromData(departmentData));
        }
        clubEmployeeDepartmentsAndTeams.teams = [];
        if (data.teams) {
            clubEmployeeDepartmentsAndTeams.teams = data.teams.data.map(teamData => Team.fromData(teamData));
        }

        Object.seal(clubEmployeeDepartmentsAndTeams);
        return clubEmployeeDepartmentsAndTeams;
    }
}
